import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/context/AuthContext";
import { fetchWorkerCards } from "../index";
import { WORKERS_LIST_LIMIT } from "./constants";
import { workersKeys } from "./keys";

export interface UseWorkersListOptions {
  enabled?: boolean;
  view?: "summary" | "full";
}

/** Lightweight worker directory list (summary view by default). */
export function useWorkersList(options: UseWorkersListOptions = {}) {
  const { isAuthenticated, isLoading: isAuthLoading } = useAuth();
  const view = options.view ?? "summary";
  const enabled = (options.enabled ?? true) && isAuthenticated && !isAuthLoading;

  return useQuery({
    queryKey: workersKeys.list(view),
    queryFn: async () => {
      const rows = await fetchWorkerCards({ view, limit: WORKERS_LIST_LIMIT });
      if (rows.length >= WORKERS_LIST_LIMIT) {
        console.warn(
          `[useWorkersList] Fetched ${WORKERS_LIST_LIMIT} workers; more may exist.`,
        );
      }
      return rows;
    },
    enabled,
  });
}
